export const selectModals = state => state.modals.modals;
export const continueModalOpenSelector = state =>
  !!state.modals.modals.filter(({ type }) => type === 'continue').length;
export const mediaModalOpenSelector = state =>
  !!state.modals.modals.filter(({ type }) => type === 'media').length;
export const previewModalOpenSelector = state =>
  !!state.modals.modals.filter(({ type }) => type === 'preview').length;
